import React from "react";

function Page2() {
  return (
    <div className="page-container">
      <div
        className="page"
        style={{
          width: "93%",
          height: "1209px",
          margin: "20px auto 20px auto",
          boxShadow: "0 0 2rem 0 rgba(136, 152, 170, 0.5)",
        }}
      >
        <div
          id="pg2Overlay"
          style={{
            WebkitUserSelect: "none",
            backgroundColor: "rgba(0,0,0,0)",
            height: "100%",
            position: "absolute",
            width: "100%",
            zIndex: "1",
          }}
        />
        <div
          id="pg2"
          style={{
            WebkitUserSelect: "none",
          }}
        >
          <img
            id="pdf2"
            alt="pdf 2"
            src="data:image/svg+xml,%3Csvg viewBox='0 0 934 1209' version='1.1' xmlns='http://www.w3.org/2000/svg'%3E%0A%3Cdefs%3E%0A%3Cstyle%3E%0A.g0%7Bfill:none%3Bstroke:%23000%3Bstroke-width:1.527%3Bstroke-miterlimit:10%3B%7D%0A%3C/style%3E%0A%3C/defs%3E%0A%3Cpath d='M54.6 73.3H836.4m-.8 0h44.8' class='g0'/%3E%0A%3C/svg%3E"
            style={{
              height: "1209px",
              width: "98%",
            }}
          />
        </div>
        <div className="text-container">
          <span
            className="t s0"
            style={{
              bottom: "1138px",
              left: "55px",
              letterSpacing: "-0.15px",
            }}
          >
            Form W-9 (Rev. 3-2024){" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "1137px",
              left: "844px",
              letterSpacing: "-0.14px",
            }}
          >
            Page{" "}
          </span>
          <span
            className="t sb"
            style={{
              bottom: "1135px",
              left: "872px",
            }}
          >
            2{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1106px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            must obtain your correct taxpayer identification number (TIN), which{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1092px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            may be your social security number (SSN), individual taxpayer{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1079px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            identification number (ITIN), adoption taxpayer identification
            number{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1065px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            (ATIN), or employer identification number (EIN), to report on an{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1051px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            information return the amount paid to you, or other amount
            reportable{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1037px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            on an information return. Examples of information returns include,
            but{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1024px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            are not limited to, the following.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1005px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            • Form 1099-INT (interest earned or paid).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "987px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            • Form 1099-DIV (dividends, including those from stocks or mutual{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "973px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            funds).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "955px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            • Form 1099-MISC (various types of income, prizes, awards, or gross{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "941px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            proceeds).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "923px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            • Form 1099-NEC (nonemployee compensation).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "904px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            • Form 1099-B (stock or mutual fund sales and certain other{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "891px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            transactions by brokers).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "872px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            • Form 1099-S (proceeds from real estate transactions).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "854px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            • Form 1099-K (merchant card and third-party network transactions).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "836px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            • Form 1098 (home mortgage interest), 1098-E (student loan
            interest),{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "822px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            and 1098-T (tuition).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "804px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            • Form 1099-C (canceled debt).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "785px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            • Form 1099-A (acquisition or abandonment of secured property).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "767px",
              left: "67px",
              letterSpacing: "0.1px",
            }}
          >
            Use Form W-9 only if you are a U.S. person (including a resident{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "753px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            alien), to provide your correct TIN.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "735px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            Caution:{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "735px",
              left: "107px",
              letterSpacing: "0.1px",
            }}
          >
            If you don’t return Form W-9 to the requester with a TIN, you{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "721px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            might be subject to backup withholding. See{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "721px",
              left: "302px",
              letterSpacing: "0.1px",
            }}
          >
            What is backup{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "707px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            withholding
          </span>
          <span
            className="t s6"
            style={{
              bottom: "707px",
              left: "118px",
              letterSpacing: "0.08px",
            }}
          >
            , later.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "689px",
              left: "66px",
              letterSpacing: "0.1px",
            }}
          >
            By signing the filled-out form
          </span>
          <span
            className="t s6"
            style={{
              bottom: "689px",
              left: "234px",
              letterSpacing: "0.08px",
            }}
          >
            , you:{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "671px",
              left: "67px",
              letterSpacing: "0.09px",
            }}
          >
            1. Certify that the TIN you are giving is correct (or you are
            waiting for a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "657px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            number to be issued);{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "639px",
              left: "67px",
              letterSpacing: "0.1px",
            }}
          >
            2. Certify that you are not subject to backup withholding; or{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "620px",
              left: "67px",
              letterSpacing: "0.1px",
            }}
          >
            3. Claim exemption from backup withholding if you are a U.S. exempt{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "607px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            payee; and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "588px",
              left: "67px",
              letterSpacing: "0.1px",
            }}
          >
            4. Certify to your non-foreign status for purposes of withholding
            under{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "574px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            chapter 3 or 4 of the Code (if applicable); and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "556px",
              left: "67px",
              letterSpacing: "0.09px",
            }}
          >
            5. Certify that FATCA code(s) entered on this form (if any)
            indicating{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "542px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            that you are exempt from the FATCA reporting is correct. See{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "542px",
              left: "394px",
              letterSpacing: "0.09px",
            }}
          >
            What Is{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "529px",
              left: "55px",
              letterSpacing: "0.12px",
            }}
          >
            FATCA Reporting
          </span>
          <span
            className="t s6"
            style={{
              bottom: "529px",
              left: "151px",
              letterSpacing: "0.09px",
            }}
          >
            , later, for further information.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "510px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            Note:{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "510px",
              left: "90px",
              letterSpacing: "0.1px",
            }}
          >
            If you are a U.S. person and a requester gives you a form other{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "497px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            than Form W-9 to{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "497px",
              left: "155px",
              letterSpacing: "0.1px",
            }}
          >
            request your TIN, you must use the requester’s form if{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "483px",
              left: "55px",
              letterSpacing: "0.07px",
            }}
          >
            it is{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "483px",
              left: "77px",
              letterSpacing: "0.1px",
            }}
          >
            substantially similar to this Form W-9.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "464px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            Definition of a U.S. person.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "464px",
              left: "214px",
              letterSpacing: "0.1px",
            }}
          >
            For federal tax purposes, you are{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "451px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            considered a U.S. person if you are:{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "432px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            • An individual who is a U.S. citizen or U.S. resident alien;{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "414px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            • A partnership, corporation, company, or association created or{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "400px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            organized in the United States or under the laws of the United
            States;{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "382px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            • An estate (other than a foreign estate); or{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "364px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            • A domestic trust (as defined in Regulations section 301.7701-7).{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "345px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            Establishing U.S. status for purposes of chapter 3 and chapter 4{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "332px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            withholding.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "332px",
              left: "130px",
              letterSpacing: "0.1px",
            }}
          >
            Payments made to foreign persons, including certain{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "318px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            distributions, allocations of income, or transfers of sales
            proceeds, may{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "304px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            be subject to withholding under chapter 3 or chapter 4 of the Code{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "290px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            (sections 1441–1474). Under those rules, if a Form W-9 or other{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "277px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            certification of non-foreign status has not been received, a
            withholding{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "263px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            agent, transferee, or partnership (payor) generally applies
            presumption{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "249px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            rules that may require the payor to withhold applicable tax from the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "235px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            recipient, owner, transferor, or partner (payee). See Pub. 515,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "222px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            Withholding of Tax on Nonresident Aliens and Foreign Entities.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "203px",
              left: "67px",
              letterSpacing: "0.1px",
            }}
          >
            The following persons must provide Form W-9 to the payor for{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "189px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            purposes of establishing its non-foreign status.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "171px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            • In the case of a disregarded entity with a U.S. owner, the U.S.
            owner{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "157px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            of the disregarded entity and not the disregarded entity.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "139px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            • In the case of a grantor trust with a U.S. grantor or other U.S.
            owner,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "125px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            generally, the U.S. grantor or other U.S. owner of the grantor trust
            and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "112px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            not the grantor trust.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "93px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            • In the case of a U.S. trust (other than a grantor trust), the U.S.
            trust{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "79px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            and not the beneficiaries of the trust.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "61px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            See Pub. 515 for more information on providing a Form W-9 or a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "47px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            certification of non-foreign status to avoid withholding.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "1106px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            Foreign person.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1106px",
              left: "579px",
              letterSpacing: "0.09px",
            }}
          >
            If you are a foreign person or the U.S. branch of a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1092px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            foreign bank that has elected to be treated as a U.S. person (under{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1079px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            Regulations section 1.1441-1(b)(2)(iv) or other applicable section
            for{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1065px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            chapter 3 or 4 purposes), do not use Form{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1065px",
              left: "719px",
              letterSpacing: "0.1px",
            }}
          >
            W-9. Instead, use the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1051px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            appropriate Form W-8 or Form 8233 (see Pub.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1051px",
              left: "740px",
              letterSpacing: "0.09px",
            }}
          >
            515). If you are a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1037px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            qualified foreign pension fund under Regulations section
            1.897(l)-1(d), or{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1024px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            a partnership that is wholly owned by qualified foreign pension
            funds,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1010px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            that is treated as a non-foreign person for purposes of section 1445{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "996px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            withholding, do not use Form W-9. Instead, use Form W-8EXP (or other{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "982px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            certification of non-foreign status).{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "964px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            Nonresident alien who becomes a resident alien.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "964px",
              left: "770px",
              letterSpacing: "0.1px",
            }}
          >
            Generally,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "964px",
              left: "829px",
              letterSpacing: "0.08px",
            }}
          >
            only a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "950px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            nonresident alien individual may use the terms of a tax{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "950px",
              left: "784px",
              letterSpacing: "0.09px",
            }}
          >
            treaty to reduce{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "937px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            or eliminate U.S. tax on certain types of income.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "937px",
              left: "750px",
              letterSpacing: "0.1px",
            }}
          >
            However, most tax{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "923px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            treaties contain a provision known as a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "923px",
              left: "700px",
              letterSpacing: "0.1px",
            }}
          >
            saving clause. Exceptions{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "909px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            specified in the saving clause may{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "909px",
              left: "674px",
              letterSpacing: "0.1px",
            }}
          >
            permit an exemption from tax to{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "895px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            continue for certain types of{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "895px",
              left: "640px",
              letterSpacing: "0.1px",
            }}
          >
            income even after the payee has otherwise{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "882px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            become a U.S.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "882px",
              left: "569px",
              letterSpacing: "0.1px",
            }}
          >
            resident alien for tax purposes.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "863px",
              left: "496px",
              letterSpacing: "0.09px",
            }}
          >
            If you are a U.S. resident alien who is relying on an exception{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "849px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            contained in the saving clause of a tax treaty to claim an exemption{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "836px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            from U.S. tax on certain types of income, you must attach a
            statement{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "822px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            to Form W-9 that specifies the following five items.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "804px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            1. The treaty country. Generally, this must be the same treaty under{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "790px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            which you claimed exemption from tax as a nonresident alien.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "772px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            2. The treaty article addressing the income.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "753px",
              left: "496px",
              letterSpacing: "0.09px",
            }}
          >
            3. The article number (or location) in the tax treaty that contains
            the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "739px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            saving clause and its exceptions.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "721px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            4. The type and amount of income that qualifies for the exemption{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "707px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            from tax.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "689px",
              left: "496px",
              letterSpacing: "0.09px",
            }}
          >
            5. Sufficient facts to justify the exemption from tax under the
            terms of{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "675px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            the treaty article.{" "}
          </span>
          <span
            className="t s4"
            style={{
              bottom: "657px",
              left: "496px",
              letterSpacing: "0.11px",
            }}
          >
            Example.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "657px",
              left: "553px",
              letterSpacing: "0.1px",
            }}
          >
            Article 20 of the U.S.-China income tax treaty allows{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "657px",
              left: "842px",
              letterSpacing: "0.08px",
            }}
          >
            an{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "643px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            exemption from tax for scholarship income received by a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "643px",
              left: "798px",
              letterSpacing: "0.1px",
            }}
          >
            Chinese{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "629px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            student temporarily present in the United States. Under{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "629px",
              left: "789px",
              letterSpacing: "0.09px",
            }}
          >
            U.S. law, this{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "616px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            student will become a resident alien for tax{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "616px",
              left: "721px",
              letterSpacing: "0.09px",
            }}
          >
            purposes if their stay in the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "602px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            United States exceeds 5{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "602px",
              left: "621px",
              letterSpacing: "0.1px",
            }}
          >
            calendar years. However, paragraph 2 of the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "588px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            first Protocol to the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "588px",
              left: "592px",
              letterSpacing: "0.1px",
            }}
          >
            U.S.-China treaty (dated April 30, 1984) allows the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "574px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            provisions of{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "574px",
              left: "557px",
              letterSpacing: "0.1px",
            }}
          >
            Article 20 to continue to apply even after the Chinese{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "561px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            student{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "561px",
              left: "529px",
              letterSpacing: "0.1px",
            }}
          >
            becomes a resident alien of the United States. A Chinese{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "547px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            student who qualifies for this exception (under paragraph 2 of{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "547px",
              left: "823px",
              letterSpacing: "0.07px",
            }}
          >
            the first{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "533px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            Protocol) and is relying on this exception to claim an{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "533px",
              left: "773px",
              letterSpacing: "0.1px",
            }}
          >
            exemption from tax{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "519px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            on their scholarship or fellowship{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "519px",
              left: "667px",
              letterSpacing: "0.11px",
            }}
          >
            income would attach to Form W-9 a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "506px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            statement that includes the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "506px",
              left: "636px",
              letterSpacing: "0.1px",
            }}
          >
            information described above to support that{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "492px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            exemption.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "474px",
              left: "496px",
              letterSpacing: "0.09px",
            }}
          >
            If you are a nonresident alien or a foreign entity, give the
            requester the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "460px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            appropriate completed Form W-8 or Form 8233.{" "}
          </span>
          <span
            className="t sd"
            style={{
              bottom: "430px",
              left: "484px",
              letterSpacing: "0.18px",
            }}
          >
            Backup Withholding{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "413px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            What is backup withholding?{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "413px",
              left: "655px",
              letterSpacing: "0.11px",
            }}
          >
            Persons making certain payments{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "413px",
              left: "844px",
              letterSpacing: "0.09px",
            }}
          >
            to you{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "399px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            must under certain conditions withhold and pay to the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "399px",
              left: "782px",
              letterSpacing: "0.1px",
            }}
          >
            IRS 24% of such{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "385px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            payments. This is called “backup withholding.”{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "385px",
              left: "743px",
              letterSpacing: "0.11px",
            }}
          >
            Payments that may be{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "371px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            subject to backup withholding include, but are not limited to,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "371px",
              left: "818px",
              letterSpacing: "0.08px",
            }}
          >
            interest,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "358px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            tax-exempt interest, dividends, broker and barter{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "358px",
              left: "755px",
              letterSpacing: "0.11px",
            }}
          >
            exchange{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "344px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            transactions, rents, royalties, nonemployee pay, payments made in{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "330px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            settlement of payment card and third-party network transactions, and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "316px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            certain payments from fishing boat operators. Real estate{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "316px",
              left: "801px",
              letterSpacing: "0.09px",
            }}
          >
            transactions{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "303px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            are not subject to backup withholding.{" "}
          </span>
          <span
            className="t v3 s6"
            style={{
              bottom: "284px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            You will not be subject to backup withholding on payments you
            receive{" "}
          </span>
          <span
            className="t v3 s6"
            style={{
              bottom: "270px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            if you give the requester your correct TIN, make the proper
            certifications,{" "}
          </span>
          <span
            className="t v3 s6"
            style={{
              bottom: "257px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            and report all your taxable interest and dividends on your tax
            return.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "238px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            Payments you receive will be subject to backup withholding if:{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "220px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            1. You do not furnish your TIN to the requester;{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "202px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            2. You do not certify your TIN when required (see the instructions
            for{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "188px",
              left: "484px",
              letterSpacing: "0.08px",
            }}
          >
            Part II for details);{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "170px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            3. The IRS tells the requester that you furnished an incorrect TIN;{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "151px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            4. The IRS tells you that you are subject to backup withholding{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "138px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            because you did not report all your interest and dividends on your
            tax{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "124px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            return (for reportable interest and dividends only); or{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "105px",
              left: "496px",
              letterSpacing: "0.09px",
            }}
          >
            5. You do not certify to the requester that you are not subject to{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "92px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            backup withholding, as described in item 4 under “
          </span>
          <span
            className="t s7"
            style={{
              bottom: "92px",
              left: "762px",
              letterSpacing: "0.09px",
            }}
          >
            By signing the filled-{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "78px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            out form
          </span>
          <span
            className="t s6"
            style={{
              bottom: "78px",
              left: "530px",
              letterSpacing: "0.1px",
            }}
          >
            ” above (for reportable interest and dividend accounts opened{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "64px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            after 1983 only).{" "}
          </span>
        </div>
      </div>
    </div>
  );
}

export default Page2;
